import * as React from 'react';

const RowFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M4 2v9h16V2H4z" />
        <g fillRule="evenodd" clipRule="evenodd">
            <circle cx={18} cy={14} r={2} />
            <circle cx={12} cy={15} r={2} />
            <circle cx={18} cy={19} r={2} />
            <circle cx={12} cy={20} r={2} />
            <circle cx={6} cy={14} r={2} />
            <circle cx={6} cy={19} r={2} />
        </g>
    </svg>
);

RowFillSvg.displayName = 'RowFillSvg';
export default RowFillSvg;
